import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";
import InputSearchClient from "../../helpers/InputSearchClient";
import InputDate from "../../helpers/InputDate";
import InputTextArea from "../../helpers/InputTextArea";
import InputDecimal from "../../helpers/InputDecimal";
import FormatDecimal from "../../helpers/FormatDecimal";


function TransferNew(props)
{

       const [errTab, setErrTab] = useState([]); 

       const [clientsCombo, setClientsCombo] = useState(null);
       const [client,setClient] = useState(null);
       const [infoCalculate, setInfoCalculate] = useState(null);

       const [row, setRow] = useState({

                fak_kontrahenci_id: props.id, 
                tytul_operacji: '', 
                data_operacji: '', 
                data_ksiegowania: '', 
                kwota: '', 
                waluta: 'PLN', 
               
            });
            var tmpRow = row;


      


    const valChangeListener = (filedName, val, correct, msg) => {   
        
   
        
             //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 

                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );                   
                    return;
                }

               
         
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;                          
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                          
 
            }   
        
        
        const goNextNew = () => {
                console.log("goNext");               
            }



        const valChecker = (fields) => {

                var allValid = true;

                    
                console.log(JSON.stringify(fields) );

                Object.entries(fields).forEach(function(entry) {

                    var xKey    = entry[0];
                    var xValue  = entry[1];                    

                    var xValidName = xKey + "_valid";

                    if(fields[xValidName] == false)
                    {
                        allValid = false;
                        if(Config.env == 'dev') console.log("Error field: " + xKey);
                    }
                    
                });
                
                return allValid;

            }

            
        const saveData = () => {
                

                if(!valChecker(row))
                {
                        props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                        return;
                }
 


                props.mainView.showProgress();
                

                fetch( Config.url + '/rest_v1_calc,transfer_add', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                    
                            props.mainView.hideProgress();

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                        if(props.onBack != undefined) props.onBack(res.result);         
                                } );                                                  
                                                            
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            props.mainView.hideProgress();
                });
                        

                return false;
            }




    const getClientsCombo = () => {
            
    
            props.mainView.showProgress();    

            fetch( Config.url + '/rest_v1_home,clients_combo', {
                method: 'POST', 
                body: JSON.stringify({all:1}), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.hideProgress();    
                    

                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                        }else    
                        {
                            setClientsCombo(res.result);                                                 
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                        props.mainView.hideProgress();    
            });
                    

            return false;
        }            
  





            const getClientDet = () => {
                    
            
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_home,client_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: row.fak_kontrahenci_id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setClient(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }

            
            const getCalcDet = () => {    

                 
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_home,client_calc', {
                        method: 'POST', 
                        body: JSON.stringify( { id: row.fak_kontrahenci_id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setInfoCalculate(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }





        const keyListener = (e)  => {


                         var code = e.keyCode ? e.keyCode : e.which;    

                            if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                            {
                                    e.target.blur();
                            } else 
                            if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                            {                                                      
                            } else
                            if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                            } else                              
                            if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                            {
                                    props.onBack();                               
                            } else props.keyListener(e);

        }


        useEffect(() => {
            
                    if(clientsCombo == null)
                    {
                        getClientsCombo();
                    }       

                    if(row.fak_kontrahenci_id >0 &&   (client == null || row.fak_kontrahenci_id != client.id)  )
                    {
                        getClientDet();
                        getCalcDet();
                    }
                                     


                    if(Config.env == "dev") console.log("TransferNew.js, listener on");
                    window.onkeydown = keyListener;

                    return () => {          
                        if(Config.env == "dev") console.log("TransferNew.js, listener off");      
                        window.onkeydown = props.keyListener;
                    };

        });            



        var title = "Wybierz klienta...";

        if(clientsCombo != null)
        {
            for(var k=0; k < clientsCombo.length; k++)
            {
                if(clientsCombo[k].v == row.fak_kontrahenci_id)
                {
                    title = clientsCombo[k].title;
                    break;
                }
            }

        }

        if(row.tytul_operacji.length > 0)
        {
            title += ", tytuł: " + row.tytul_operacji;
        }

        if(row.kwota.length > 0)
        {
            title += ", kwota: " + row.kwota + " " + row.waluta;
        }



        document.title = "Nowy przelew";



         return <div className="view_content">
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>    

                    <h3 className="dash_header"> {title} </h3>

                    <form className="eForm bg_center">


                            <div className="form_tab">

                                    <div className="form_control">
                                            <div className="fieldName">Klient*</div>
                                            <InputCombo items={clientsCombo}   userData={props.userData} value={row.fak_kontrahenci_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fak_kontrahenci_id" placeholder={""} className=' w300 ' req='1' firstUp="0" />
                                    </div>

                                    <div className="form_split"></div>

                                    <div className="form_control">
                                            <div className="fieldName">Tytuł operacji*</div>
                                            <InputText   userData={props.userData} value={row.tytul_operacji} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul_operacji" placeholder={"Tytuł"} className=' w200 ' req='1' firstUp="0" />
                                    </div>

                                 
                                
                                    <div className="form_control">
                                            <div className="fieldName">Data operacji*</div>
                                            <InputDate   value={row.data_operacji} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_operacji" placeholder={""} className='  ' req='1' firstUp="0" />
                                    </div>   


                                    <div className="form_control">
                                            <div className="fieldName">Waluta*</div>
                                            <InputCombo items={ [  {v:'PLN',title:'Polski złoty'},  {v:'CZK',title:'Korona czeska'},    {v:'EUR',title:'Euro'}, {v:'USD',title:'Dolar USD'},        ] }   userData={props.userData} value={row.waluta} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="waluta" placeholder={""} className='   ' req='1' firstUp="0" />
                                    </div>

                            
                                    <div className="form_control">
                                            <div className="fieldName">Kwota*</div>
                                            <InputDecimal   value={row.kwota} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kwota" placeholder={""} className='  ' req='1' firstUp="0" />
                                    </div> 

                            </div>
 
 
 
 

                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                        <div className="btn" onClick={saveData}>zapisz [ctrl + s ]</div>
                                                        &nbsp;&nbsp;
                                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                            </div>


                    </form>


                    {
                        client != null && infoCalculate != null &&
                        <Fragment>
                                    <br/>

                                    <div className="client_info">                           
                                        <div>NIP: {client.nip} </div>
                                        <div>{client.zm_ulica} {client.zm_nr_domu} {client.zm_nr_mieszkania} {client.zm_kod_pocztowy} {client.zm_miejscowosc} </div>
                                        <div>{client.telefon_kontaktowy} {client.email_kontaktowy}</div>
                                        <div>
                                                {   
                                                    client.e_faktura == 1 &&
                                                    <div>e-faktura: {client.e_mail_dla_faktur}</div>
                                                }
                                        </div>
                                    </div>

                                    <div className="client_info">
                                    Aktualne saldo:&nbsp; 
                                    {
                                        infoCalculate.saldo >= 0 &&
                                        <span className="bold_green"><FormatDecimal value={infoCalculate.saldo} /> zł </span>
                                    }
                                    {
                                        infoCalculate.saldo < 0 &&
                                        <span className="bold_red"><FormatDecimal value={infoCalculate.saldo} /> zł </span>
                                    }                        
                                    &nbsp; 
                                    Zaległości po terminie: <b><FormatDecimal value={infoCalculate.suma_po_terminie} /> zł </b>
                                    &nbsp;
                                    Ostatnio wystawiona faktura: <b>{infoCalculate.ostatnia_faktura.numer}</b> z dnia {infoCalculate.ostatnia_faktura.data}
                                </div>

                        </Fragment>
                    }
                   

         </div>
}

export default TransferNew;


